module.exports = __webpack_public_path__ + "static/media/testimonial_empty@2x.fd3a249b.png";